import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import initPlayer from 'website/module/player';
import facebookWidgets from 'website/module/ui/facebookWidgets';
import thirdNav from 'website/module/ui/third-nav';

// bootstrap the application / store
applicationBootstrap().then(() => {
  initPlayer();

  thirdNav();

  roller();

  facebookWidgets();
});
